const { alert } = require('site/components/alerts');

/**
 * Appends or updates a parameter in the URL
 * @param {string} url - Original URL
 * @param {Object} params - Parameters to append or update
 * @returns {string} URL with appended or updated parameters
 */
function appendToUrl(url, params) {
    const urlObj = new URL(url);

    Object.keys(params).forEach((key) => {
        urlObj.searchParams.set(key, params[key]);
    });

    return urlObj.toString();
}

// Function to set a cookie
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Expiry in days
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
}

// Function to get a cookie
function getCookie(name) {
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.indexOf(`${name}=`) === 0) {
            return cookie.substring(name.length + 1);
        }
    }
    return '';
}

function clearShipmentSelection() {
    // uncheck selected shipment
    $('input[name="selectedShipment"]').prop('checked', false);
}

function handleStateModal() {
    $(document).ready(() => {
        const cookieState = getCookie('state');

        const selectStateDropdown = $('#selectStateDropdownBtn');

        // const restrictedStates = selectStateDropdown.length && selectStateDropdown.data('restrictedstates')
        //     ? selectStateDropdown.data('restrictedstates').split(',')
        //     : [];

        const wineryStates = selectStateDropdown.length && selectStateDropdown.data('wineryonlystates')
            ? selectStateDropdown.data('wineryonlystates').split(',')
            : [];

        if (!cookieState) {
            $('#wineClubStateModal').modal('show');
        }

        if (wineryStates.includes(cookieState)) {
            // show winery only club
            $('.products-list a').hide();
            $('.products-list a[data-clubId="wineryOnly"]').show();
        } else {
            // show all products except winery only
            $('.products-list a[data-clubId="wineryOnly"]').hide();
        }

        // Club Product details club selection dropdown

        // Extract selectedClub parameter from the URL
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const selectedClub = urlParams.get('selectedClub');

        // Get elements for dropdown
        // const selectClubDropdownBtn = $("#selectClubDropdownBtn");
        const firstClubItem = $('.select-club-dropdown-item').first();
        const firstClubName = firstClubItem.data('clubname');
        const firstClubID = firstClubItem.data('clubid');

        // Reset all
        $('.select-club-dropdown-item').attr('data-isSelected', 'false');

        // select default to the first club if no valid selection is found
        if (!selectedClub || selectedClub === firstClubID) {
            firstClubItem.attr('data-isSelected', 'true');
            // Update button with first club's name
            $('#selectClubDropdownBtn').text(firstClubName);
        } else {
            // Select the club matching the 'selectedClub' parameter
            $(`.select-club-dropdown-item[data-clubid=${selectedClub}]`).attr('data-isSelected', 'true');
            const selectedDropdownClubName = $(`.select-club-dropdown-item[data-clubid=${selectedClub}]`).data('clubname');
            // Update Dropdown button with selected club's name
            $('#selectClubDropdownBtn').text(selectedDropdownClubName);
        }

        $('.clickOkBtn').click(() => {
            const selectedState = $('#selectStateDropdownBtn').data('selectedstate');

            if (!selectedState) {
                alert({
                    context: 'alert-danger',
                    dismissible: true,
                    message: 'Please select a state',
                });
                return;
            }

            setCookie('state', selectedState, 7);

            if (wineryStates.includes(selectedState)) {
                // show winery only club
                $('.products-list a').hide();
                $('.products-list a[data-clubId="wineryOnly"]').show();
            } else {
                // show all products except winery only
                $('.products-list a[data-clubId="wineryOnly"]').hide();
            }

            $('#wineClubStateModal').modal('hide');
        });
    });
}

function bindEvents() {
    // Deselect shipment when the modal is closed by clicking outside
    $('#wineClubShipmentModal').on('hidden.bs.modal', () => {
        clearShipmentSelection();
    });

    // Deselect shipment when the close button is clicked
    $('.wineClubShipmentCloseBtn').on('click', () => {
        clearShipmentSelection();
    });

    // wine club footer
    $(window).on('scroll', () => {
        const categoryDiv = $('.category');
        if ($(window).scrollTop() + $(window).height() >= categoryDiv.offset().top + categoryDiv.outerHeight()) {
            $('.wine-club-footer-wrapper').css('position', 'static');
        } else {
            $('.wine-club-footer-wrapper').css('position', 'fixed');
        }
    });
}

function adjustShipmentLayout() {
    // Select all visible shipment cards within the wrapper
    const $visibleDivs = $('.shipment-wrapper > div').not('.d-none');

    // If exactly one visible div is present
    if ($visibleDivs.length === 1) {
        $visibleDivs.css({
            'grid-column': 'span 3',
            'border-right': 'none',
        });
    } else {
        // Reset styles if more than one div is visible
        $visibleDivs.css({
            'grid-column': '',
            'border-right': '',
        });
    }
}

function handleAddToCart() {
    $('.join-club-btn').on('click', () => {
        const selectedValue = $('input[name="selectedShipment"]:checked').val();
        const url = $('.join-club-btn').data('url');
        let currentShipment = false;
        let futureShipment = false;
        let isBothShipmentSelected = false;
        // show error message if shipment is not selected
        if (!selectedValue) {
            alert({
                context: 'alert-danger',
                dismissible: true,
                message: 'Please select Shipment',
            });
            return;
        }

        $.spinner().start();

        // get both shipment products
        const currentShipmentProducts = $('.join-club-btn').data('current-shipment');
        const futureShipmentProducts = $('.join-club-btn').data('future-shipment');
        const wineClubMembershipID = $('.join-club-btn').data('club-membershipid');

        const finalProducts = [{ pid: wineClubMembershipID, qty: 1 }];

        if (selectedValue === 'current') {
            currentShipment = true;
            finalProducts.push(...currentShipmentProducts.map(
                (product) => ({
                    pid: product.ID,
                    qty: product.quantity,
                }),
            ));
        } else if (selectedValue === 'future') {
            futureShipment = true;
            finalProducts.push(...futureShipmentProducts.map(
                (product) => ({
                    pid: product.ID,
                    qty: product.quantity,
                }),
            ));
        } else if (selectedValue === 'both') {
            finalProducts.push(...currentShipmentProducts.map(
                (product) => ({
                    pid: product.ID,
                    qty: product.quantity,
                }),
            ));
            finalProducts.push(...futureShipmentProducts.map(
                (product) => ({
                    pid: product.ID,
                    qty: product.quantity,
                }),
            ));
            isBothShipmentSelected = true;
        }

        const pidsObjString = JSON.stringify(finalProducts);

        const data = {
            isWineClub: true,
            pidsObj: pidsObjString,
            isBothShipmentSelected,
            currentShipment,
            futureShipment,
            pid: wineClubMembershipID,
            quantity: 1,
        };

        $.ajax({
            url,
            type: 'post',
            dataType: 'json',
            data,
            success: (response) => {
                $('.minicart').trigger('count:update', response);
                $('body').trigger('product:afterAddToCart', response);

                if (response.error && response.message) {
                    alert({
                        context: 'alert-danger',
                        dismissible: true,
                        message: response.message,
                    });
                }

                $.spinner().stop();
            },
            error: (err) => {
                $.spinner().stop();
                alert({
                    context: 'alert-danger',
                    dismissible: true,
                    message: err.responseJSON.message,
                });
            },
        });

        $('#wineClubShipmentModal').modal('hide');
        clearShipmentSelection();
    });
}

function handleStateDropdown() {
    const selectStateDropdownBtn = $('#selectStateDropdownBtn');
    const customDropdownMenu = $('.custom-dropdown-menu');

    const restrictedStates = selectStateDropdownBtn.length && selectStateDropdownBtn.data('restrictedstates') ? selectStateDropdownBtn.data('restrictedstates').split(',') : [];
    const wineryStates = selectStateDropdownBtn.length && selectStateDropdownBtn.data('wineryonlystates') ? selectStateDropdownBtn.data('wineryonlystates').split(',') : [];

    selectStateDropdownBtn.click(function () {
        if ($(this).attr('aria-expanded') === 'false') {
            // Show the dropdown
            customDropdownMenu.removeClass('d-none').addClass('d-block');
            $(this).attr('aria-expanded', 'true');
        } else {
            // Hide the dropdown if it's already open
            customDropdownMenu.removeClass('d-block').addClass('d-none');
            $(this).attr('aria-expanded', 'false');
        }
    });

    $('.custom-dropdown-item').click(function () {
        // Reset
        $('.state-restriction-message').addClass('d-none');
        $('.winery-state-message').addClass('d-none');
        $('.clickOkBtn').removeAttr('disabled');
        $('.modalCloseBtn').removeAttr('disabled');

        // Get select state code(id) and value(name)
        const selectedStateName = $(this).data('value');
        const selectedStateCode = $(this).data('code');

        if (!selectedStateCode) {
            alert({
                context: 'alert-danger',
                dismissible: true,
                message: 'Please select a state',
            });
            return;
        }

        // Update selected value
        selectStateDropdownBtn.text(selectedStateName);
        selectStateDropdownBtn.data('selectedstate', selectedStateCode);
        customDropdownMenu.removeClass('d-block').addClass('d-none');
        selectStateDropdownBtn.attr('aria-expanded', 'false');

        if (selectedStateCode === 'AL') {
            $('.state-restriction-message').removeClass('d-none');
            return;
        }

        // check if selected state is in restricted state
        if (restrictedStates.includes(selectedStateCode)) {
            $('.state-restriction-message').removeClass('d-none');
            $('.clickOkBtn').attr('disabled', true);
            $('.modalCloseBtn').attr('disabled', true);
            return;
        }

        // Check if the selected state is winery state
        if (wineryStates.includes(selectedStateCode)) {
            // show winery only club
            $('.winery-state-message').removeClass('d-none');
        }
    });
}

function handleClubSelectionDropdown() {
    // Get elements for dropdown button
    const selectClubDropdownBtn = $('#selectClubDropdownBtn');
    const customClubDropdownMenu = $('.custom-club-dropdown-menu');

    selectClubDropdownBtn.click(function () {
        if ($(this).attr('aria-expanded') === 'false') {
            // Show the dropdown
            customClubDropdownMenu.removeClass('d-none').addClass('d-block');
            $(this).attr('aria-expanded', 'true');
        } else {
            // Hide the dropdown if it's already open
            customClubDropdownMenu.removeClass('d-block').addClass('d-none');
            $(this).attr('aria-expanded', 'false');
        }
    });

    $('.select-club-dropdown-item').click(function () {
        // Get selected club's name and ID
        const selectedClubName = $(this).data('clubname');
        const selectedClubId = $(this).data('clubid');
        // Update Dropdown button with selected club's name
        selectClubDropdownBtn.text(selectedClubName);
        $(this).attr('data-isSelected', 'true');
        customClubDropdownMenu.removeClass('d-block').addClass('d-none');
        selectClubDropdownBtn.attr('aria-expanded', 'false');

        // Get url info
        const url = window.location.href;
        const urlParams = {
            selectedClub: selectedClubId,
        };
        // Update url
        window.location.href = appendToUrl(url, urlParams);
    });
}

module.exports = {
    bindEvents,
    handleStateModal,
    handleAddToCart,
    adjustShipmentLayout,
    handleStateDropdown,
    handleClubSelectionDropdown,
};
